<template>

<div class="menu">

    <app-button class="menu-toggle" v-if="window.is.mobile" text="Account menu" v-on:click="$emit('toggle')" :caret="true" />

    <template v-if="isSessionCustomer && (expanded || !window.is.mobile)">

	<com-section to="Account/Profile" icon="profile" :text="page.customer_menu_profile" :parent="true">

		<com-item to="Account/Profile/About" :text="page.customer_menu_profile_about" />
		<com-item to="Account/Profile/Contact" :text="page.customer_menu_profile_contact" />
		<com-item to="Account/Profile/Password" :text="page.customer_menu_profile_password" v-if="session.platform === $constants.platform.web" />

	</com-section>

	<com-section to="Account/Events" icon="events" :text="page.customer_menu_events" :count="session.count.events" />
	<com-section to="Account/Offers" icon="offers" :text="page.customer_menu_offers" :count="session.count.offers" />
	<com-section to="Account/Reviews" icon="reviews" :text="page.customer_menu_reviews" :count="session.count.reviews" />
	<com-section to="Account/Refer" icon="refer" :text="page.customer_menu_refer" />

    </template>

    <template v-if="isSessionBusiness && (expanded || !window.is.mobile)">

	<com-section to="Account/Profile" icon="business" :text="page.business_menu_profile" :parent="true">

		<com-item to="Account/Profile/About" :text="page.business_menu_profile_about" />

        <com-divide v-if="session.business.premium" />

		<com-item v-if="session.business.premium" to="Account/Profile/Blog" :text="page.business_menu_profile_blog" />
		<com-item v-if="session.business.premium" to="Account/Profile/Bookings" :text="page.business_menu_profile_bookings" />
		<com-item v-if="session.business.premium" to="Account/Profile/Events" :text="page.business_menu_profile_events" />
		<com-item v-if="session.business.premium" to="Account/Profile/Offers" :text="page.business_menu_profile_offers" />
		<com-item v-if="session.business.premium" to="Account/Profile/People" :text="page.business_menu_profile_people" />
		<com-item v-if="session.business.premium" to="Account/Profile/Prices" :text="page.business_menu_profile_prices" />
		<com-item v-if="session.business.premium" to="Account/Profile/Photos" :text="page.business_menu_profile_photos" />
        <com-item v-if="session.business.premium" to="Account/Profile/Vacancies" :text="page.business_menu_profile_vacancies" />

        <com-divide />

		<com-item to="Account/Profile/Owner" :text="page.business_menu_profile_owner" />
		<com-item to="Account/Profile/Password" :text="page.business_menu_profile_password" />

	</com-section>

	<com-section to="Account/Reviews" icon="reviews" :text="page.business_menu_reviews" :count="session.business.count.reviews" />
	<com-section v-if="session.business.premium" to="Account/Incentives" icon="offers" :text="page.business_menu_incentives" />
	<com-section v-if="session.business.premium" to="Account/Adverts" icon="advert" :text="page.business_menu_adverts" />
	<com-section v-if="session.business.premium" to="Account/Suppliers" icon="supplier" :text="page.business_menu_suppliers" />
	<com-section v-if="session.business.premium" to="Account/Resources" icon="resource" :text="page.business_menu_resources" />

    </template>

</div>

</template>

<script>

import comSection from './menu/Section'
import comItem from './menu/Item'
import comDivide from './menu/Divide'

export default {

    props: ['expanded'],

	components: {
		'com-item': comItem,
        'com-section': comSection,
        'com-divide': comDivide
    }

}

</script>

<style scoped>

.menu {
	display: flex;
	flex-direction: column;
	margin-right: 40px;
}

.is-tablet .menu {
    margin-right: 20px;
}

.is-mobile .menu {
    margin-right: 0px;
}

.menu-toggle {
    margin-bottom: 20px;
}

</style>